export const contentCardContainerCss = {
  padding: "40px 40px 32px",
};
